const UnifiedComplete = () => {
  return (
    <div className="sh_login">
      <div className="sh_login-bleed">
        <main className="sh_login-bg">
          <div className="container sh_login-container">
            <div className="row justify-content-center">
              <div className="col-12">
                <div className="d-flex justify-content-center">
                  <div className="sh_login-card">
                    <div className="sh_login-card-inner text-center">
                      <h4 className="font-weight-bold mb-3" style={{ color: "#28a745" }}>
                        You're all done!
                      </h4>
                      <p className="text-muted mb-0">
                        All your forms have been submitted successfully. You may now close this
                        window.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default UnifiedComplete;

